const MAX_ENTRIES = 80;
const MAX_MESSAGE = 500;
const MAX_STACK = 1500;
const CONSOLE_METHODS = ['log', 'info', 'warn', 'debug', 'error'];

const entries = [];

function clip(value, max) {
  const text = String(value ?? '')
    .replace(/Bearer\s+[A-Za-z0-9\-._~+/]+=*/gi, 'Bearer [redacted]')
    .replace(/\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, '[redacted jwt]');
  if (text.length <= max) return text;
  return `${text.slice(0, Math.max(0, max - 1))}…`;
}

function push(entry) {
  entries.push({
    time: new Date().toISOString(),
    kind: entry.kind || 'error',
    message: clip(entry.message, MAX_MESSAGE),
    stack: clip(entry.stack, MAX_STACK),
    source: clip(entry.source, 300)
  });
  if (entries.length > MAX_ENTRIES) entries.shift();
}

function formatArg(arg) {
  if (arg instanceof Error) return arg.stack || arg.message;
  if (typeof arg === 'string') return arg;
  try {
    return JSON.stringify(arg);
  } catch {
    return String(arg);
  }
}

export function installClientErrorLog() {
  if (typeof window === 'undefined' || window.__bugReportErrorLogInstalled) return;
  window.__bugReportErrorLogInstalled = true;

  window.addEventListener('error', (event) => {
    push({
      kind: 'error',
      message: event.message,
      stack: event.error?.stack,
      source: event.filename ? `${event.filename}:${event.lineno}:${event.colno}` : ''
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    push({
      kind: 'unhandledrejection',
      message: reason instanceof Error ? reason.message : String(reason ?? 'Unhandled rejection'),
      stack: reason instanceof Error ? reason.stack : ''
    });
  });

  CONSOLE_METHODS.forEach((method) => {
    const original = console[method].bind(console);
    console[method] = (...args) => {
      try {
        const error = args.find((arg) => arg instanceof Error);
        push({
          kind: `console.${method}`,
          message: args.map(formatArg).join(' '),
          stack: method === 'error' ? error?.stack || '' : ''
        });
      } catch {
        // Keep the original console method working even if the buffer cannot record an entry.
      }
      original(...args);
    };
  });
}

export function snapshotClientErrors() {
  return entries.map((entry) => ({ ...entry }));
}
